import Loading from '../../Common/Loading';
import { useProceduresChartsDataContext } from './hooks/useProceduresChartsDataContext';
import { ProceduresTop } from './ProceduresTop';
import { ProceduresByModality } from './ProceduresByModality';
import { ProceduresModalityByYear } from './ProceduresModalityByYear';
import { ProceduresUtiDistribution } from './ProceduresUtiDistribution';
import { ProceduresTopTable } from './ProceduresTopTable';

export const Charts = () => {
    const { isLoading } = useProceduresChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <ProceduresTop />
                <ProceduresTopTable />
            </div>
            <div className="charts-side-by-side-dashboards">
                <ProceduresUtiDistribution />
                <ProceduresModalityByYear />
            </div>
            <div className="charts-side-by-side-dashboards">
                <ProceduresByModality />
            </div>
        </>
    );
};
